// extracted by mini-css-extract-plugin
export default {"colors":"'./colors.css'","lifeomicCanvas":"#F1F8FB","lifeomicBlue":"#02bff1"};